<template>
  <div v-if="venueCampaign && activeVenue">
    <vx-card no-shadow>
      <h2 class="my-4">Email</h2>
      <h5 class="my-5" v-if="!isEditable">
        <b>Note: Cannot be saved as campaign has status {{ statusObject(venueCampaign.status).text }}.</b>
      </h5>

      <div class="col-8 mb-5">
        <p class="mb-0">
          The campaign design has been modified to match the design of this venue ({{
            activeVenue.name
          }}).<br />
        </p>
        <p class="b-5">
          You can specify dynamic content by using the <b>Merge Tags</b> feature in the mail editor.<br />
        </p>
      </div>

      <div class="vx-row mb-6">
        <div class="vx-col sm:w-1/5 w-full">
          <span>Email subject</span>
        </div>
        <div class="vx-col sm:w-4/5 w-full max-w-xl">
          <vs-input
            :placeholder="'Mail from {{venue_name}}'"
            v-model="venueCampaign.emailSubject"
            class="w-full"
          />
        </div>
      </div>

      <email-template-editor
        :email-json="venueCampaign.emailJson"
        :venue-logo-url="venueCampaign.venueLogoUrl"
        ref="emailEditor"
      />

      <!-- Save & Remove Button -->
      <vs-row vs-justify="flex-end" class="flex flex-wrap items-center" style="margin-top: 32px">
        <vs-button v-if="isEditable" id="save-button" @click="onClickSave" class="mt-2"
          >Save Changes</vs-button
        >
      </vs-row>
    </vx-card>

    <vx-card no-shadow> </vx-card>
  </div>
</template>

<script>
import _ from "lodash";
import { mapGetters } from "vuex";

import EmailTemplateEditor from "@/components/EmailTemplateEditor/EmailTemplateEditor.vue";
import campaignMixin from "@/views/mixins/campaignMixin";

export default {
  components: {
    EmailTemplateEditor,
  },
  mixins: [campaignMixin],
  props: ["venueCampaign", "isEditable"],
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      consentTypes: "templates/consentTypes",
      activeVenue: "venues/activeVenue",
    }),
    consentTypeOptions() {
      return this.consentTypes.map((e, i) => {
        return { text: e, value: i };
      });
    },
  },
  methods: {
    async onClickSave() {
      const emailExport = await this.$refs.emailEditor.export();

      this.venueCampaign.emailJson = JSON.stringify(emailExport.design);
      // this.venueCampaign.emailHtml = emailExport.html;

      this.$emit("onSave");
    },
  },
};
</script>

<style lang="scss">
</style>